import { FormEvent, useState } from 'react';

import Modal from '../Modal';
import RegionModal from '../../containers/RegionModal';
import QBLogo from '../../../images/qb-logo-vertical.svg';
import Img1 from '../../../images/1.png';
import Img2 from '../../../images/2.png';
import Img3 from '../../../images/3.png';
import { LoginActionCreator } from '../../actionCreators';
import './styles.css';

export interface LoginStateProps {
  error?: string;
  loading: boolean;
  loggedIn: boolean;
}

export type LoginDispatchProps = {
  login: LoginActionCreator;
};

type LoginProps = LoginStateProps & LoginDispatchProps;

export default function Login(props: LoginProps): JSX.Element {
  const { error, loading, loggedIn, login } = props;

  const [username, setUsername] = useState('');

  const year = new Date().getFullYear();

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    login({ login: username, password: 'quickblox' });
  };

  return (
    <div className="login-screen">
      <Modal>{loggedIn ? <RegionModal /> : null}</Modal>
      <img className="logo" src={QBLogo} />
      <form className="login" onSubmit={handleSubmit}>
        <h2 className="title">Conference Calling Demo</h2>
        <p>
          Welcome to Conference Calling Demo from QuickBlox.
          <br />
          This service is for guidance only and is not a final product for
          commercial use.
        </p>
        <h4 className="subtitle">To start the demo you just need:</h4>
        <div className="steps">
          <div className="step">
            <img src={Img1} />
            <label htmlFor="name">
              <span className="number">1.&nbsp;</span>
              Input your <b>Name</b>
            </label>
            <input
              autoFocus
              disabled={loading}
              id="name"
              name="username"
              onChange={(e) => setUsername(e.target.value)}
              pattern="^(?=.{3,20}$)(?!.*([\s])\1{2})[\w\s]+$"
              placeholder="Username"
              required
              title="Use alphanumeric characters and spaces in a range from 3 to 20. Cannot contain more than one space in a row."
              type="text"
              value={username}
            />
          </div>
          <div className="step">
            <img src={Img2} />
            <label htmlFor="submit">
              <span className="number">2.&nbsp;</span>
              Click <b>«Next»</b> button below and select server region
            </label>
          </div>
          <div className="step">
            <img src={Img3} />
            <label>
              <span className="number">3.&nbsp;</span>
              <b>«Share Link»</b> from next screen to interlocutor(s) and start
              your conversation
            </label>
          </div>
        </div>
        {error ? <span className="error">{error}</span> : null}
        <button disabled={loading} id="submit" type="submit">
          {loading ? <div className="loader" /> : 'Next'}
        </button>
      </form>
      <span className="copyright">
        Copyright © {year} QuickBlox. All rights reserved.
      </span>
    </div>
  );
}
